import React from "react";
import "./Contact.css";

export default function Contact() {
  return <div>Contact</div>;
}
